import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function fetchCountries() {
  const { data } = await axios.get(`${API}/countries`);
  return data;
}

export async function fetchCountry(code) {
  const { data } = await axios.get(`${API}/countries/${code}`);
  return data;
}

export async function fetchNeighbors(code, lang = "ar") {
  const { data } = await axios.get(`${API}/countries/${code}/neighbors`, { params: { lang } });
  return data;
}
